import { unref } from "vue";
import { eachDayOfInterval, isWeekend } from "date-fns";

import type { MaybeRef } from "vue";

type TypeOfStay = "weekdays" | "weekend" | "mixed";

export const typeOfStay = (
  start: MaybeRef<Date>,
  end: MaybeRef<Date>,
): TypeOfStay => {
  const allDaysInInterval = eachDayOfInterval({
    start: unref(start),
    end: unref(end),
  });

  let hasWeekdays = false;
  let hasWeekends = false;

  for (const day of allDaysInInterval) {
    if (isWeekend(day)) {
      hasWeekends = true;
    } else {
      hasWeekdays = true;
    }
  }
  if (hasWeekdays && hasWeekends) return "mixed";
  if (hasWeekdays) return "weekdays";

  return "weekend";
};
